import React, { FunctionComponent, useState, useEffect } from 'react';

/**
 * Input that calls onChangeBlur when input blurs or enter is pressed
 */
export const BlurInput: FunctionComponent<
  React.InputHTMLAttributes<HTMLInputElement> & {
    onChangeBlur: (value: string) => void;
  }
> = ({ value, onChange, onFocus, onBlur, onChangeBlur, ...rest }) => {
  const [cachedValue, setCachedValue] = useState(value);
  const [focused, setFocused] = useState(false);

  // bind the local value to the provided value when input is not in focus
  useEffect(() => {
    if (!focused) setCachedValue(value);
  }, [focused, value]);

  return (
    <input
      {...rest}
      type="text"
      value={cachedValue}
      onChange={(event) => {
        setCachedValue(event.target.value);
        onChange?.(event);
      }}
      onFocus={(event) => {
        setFocused(true);
        onFocus?.(event);
      }}
      onBlur={(event) => {
        setFocused(false);
        onBlur?.(event);
        // trigger onChangeBlur on blur if the value has changed
        if (value !== cachedValue) onChangeBlur(cachedValue as string);
      }}
      onKeyDown={(event) => {
        // also trigger onChangeBlur on enter
        if (event.keyCode === 13 && value !== cachedValue) {
          onChangeBlur(cachedValue as string);
        }
      }}
    />
  );
};
